<template>
  <div class="head">
    <div class="headBox flex align-center justify-between">
      <div class="headLeft">
        <img :src="logo === 2 ? logo2 : logo1" alt="">
      </div>
      <div class="headRight">
        <a href="http://zjzk.emof.cn/" class="headRightTel">
          返回首页
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headerpage",
  data() {
    return {
      logo1:require('@/assets/images/logo.png'),
      logo2:require('@/assets/images/logo.png'),
    }
  },
  components: {},
  created() {

  },
  props:{
    logo:{
      type: Number,
      default: 1
    },
  },
  methods: {
    // 跳转
    to(path) {
      this.$router.push(path)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.head {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0a2240;

  .headBox {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    justify-content: space-between;

    .headLeft {
        img {
          //width: 520px;
          height: 46px;
          //margin-top: 19px;
        }
    }

    .headRight {
      display: flex;
      justify-content: space-between;

      .headRightTel {
        font-size: 16px;
        color: #ffffff;
        width: 156px;
        height: 40px;
        line-height: 40px;
        background-color: #ff9600;
        border-radius: 20px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

</style>


